/* eslint-disable react/prop-types*/
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { PropTypes } from 'prop-types'

import { Card } from 'primereact/card'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import { Dialog } from 'primereact/dialog'

import back from '../assets/images/back.svg'
import { Paginator } from 'primereact/paginator'
import SubBrandComponent from '../components/SubBrandComponent'
import { growth, booleanList } from '../_common/utils'
import { companyValidation } from '../_validation'
import { userActions } from '../_actions'

function ManageCompanyComponent({ currentPage, masterList, companyList, getCompanyByPage, totalRecords,
  bulkUpdate, deleteCompany, activeCompany, type, typeId, bulkUpdateSuccessMessage, showGrowlMessage,
  clearAllMessages, bulkUpdatesubBrand, isCompanyLoading, bulkUpdateResponse }) {
  const [pageSize] = useState(20)
  const [search, setSearch] = useState('')
  const [companyData, setCompanyData] = useState([])
  const history = useHistory()
  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false)
  const [deleteRow, setDeleteRow] = useState(false)
  const [first, setFirst] = useState(currentPage ? currentPage * pageSize : 0)
  //const [rows, setRows] = useState(10)
  const [updatedRows, setUpdatedRows] = useState((companyData && companyData.filter(f => f.isUpdated === true)).length > 0)
  const [updateCount, setUpdateCount] = useState(0)
  const [duplicateCount, setDuplicateCount] = useState(0)
  const [failedCount, setFailedCount] = useState(0)
  const [bulkUpdateResult, setBulkUpdateResult] = useState(null)
  //console.log(bulkUpdateResult)
  useEffect(() => {
    if (bulkUpdateResponse) {
      setBulkUpdateResult(bulkUpdateResponse)
      setTimeout(function () { setBulkUpdateResult(null) }, 60000)
    }
    if (bulkUpdateResult) {
      setUpdateCount(bulkUpdateResult['updated']?.length)
      setDuplicateCount(bulkUpdateResult['duplicate']?.length)
      //setFailedCount(bulkUpdateResult['failed'].length)
    }
    setCompanyProcess()
    setTimeout(() => {
      const frozenBody = document.querySelector('.ui-table-frozen-view > .ui-table-scrollable-body')
      if (frozenBody) {
        const frozenBodyStyle = frozenBody['style']
        if (frozenBodyStyle['marginBottom'] !== 'unset') {
          frozenBodyStyle['paddingBottom'] = frozenBodyStyle['marginBottom']
          frozenBodyStyle['marginBottom'] = 'unset'
        }
      }
    }, 0)
  }, [bulkUpdateResponse, bulkUpdateResult, companyList])
  useEffect(() => {
    if (type === 'search')
      getCompanyByPage(0, 20, typeId, type, '', '')
    else
      getCompanyByPage(0, 20, '', type, typeId, '')
    setFirst(0)
  }, [])
  const setCompanyProcess = () => {
    const companyArray = []
    for (let i = 0; i < companyList.length; i++) {
      const company = companyList[i]
      companyArray.push({
        'action': '',
        'active': company.active,
        'name': company.name,
        'ticker': company.ticker,
        //'financialHealthGrade': company.financialStrength,
        'marketCapitalization': company.marketCapitalization,
        'sector': {
          id: company.sector ? company.sector.sectorId : 0,
          name: company.sector ? company.sector.name : '',
        },
        'industry': {
          id: company.industry ? company.industry.industryId : 0,
          name: company.industry ? company.industry.name : ''
        },
        'exchange': {
          id: company.exchange ? company.exchange.exchangeId : 0,
          name: company.exchange ? company.exchange.name : '',
        },
        'companyId': company.companyId,
        'exchangeCountry': company.exchangeCountry,
        'earningsYeild': company.earningsYeild,
        'barriers': company.barriers,
        'financialStrength': company.financialStrength,
        'momentum': company.momentum,
        'underValued': company.underValued,
        'growthType': company.growthType,
        'topNewsBuy': company.topNewsBuy,
        'dividendLeader': company.dividendLeader,
        'sociallyResponsible': company.sociallyResponsible,
        'watchlist': company.watchlist,
        'intersection': company.intersection,
        'isUpdated': false,
        'logoPath': company.logoPath,
        'subBrandsCompany': company.subBrandsCompany,
        'encodedImageString': company.encodedImageString,
        'logoURL': company.logoURL,
        'createdBy': company.createdBy,
        'updatedBy': userActions.getCurrentUser(),
        'createdOn': company.createdOn,
      })
    }
    setCompanyData(companyArray)
  }

  // const cols = [
  //   { field: 'action', header: 'ACTION' },
  //   { field: 'companyId', header: '' },
  //   { field: 'companyName', header: 'COMPANY NAME' },
  //   { field: 'ticker', header: ' TICKER' },
  //   { field: 'grade', header: 'GRADE' },
  //   { field: 'marketcap', header: ' MARKET CAP' },
  //   { field: 'sector.name', header: 'SECTOR' },
  //   { field: 'industry', header: 'INDUSTRY' },
  //   { field: 'exchange', header: 'EXCHANGE' },
  //   { field: 'exchangeCountry', header: 'Exchange Country'.toUpperCase() },
  //   { field: 'earningsYeild', header: 'earningsYield'.toUpperCase() },
  //   { field: 'barriers', header: 'barriers'.toUpperCase() },
  //   { field: 'financialStrength', header: 'financialStrength'.toUpperCase() },
  //   { field: 'momentum', header: 'momentum'.toUpperCase() },
  //   { field: 'underValued', header: 'underValued'.toUpperCase() },
  //   { field: 'growthType', header: 'growthType'.toUpperCase() },
  //   { field: 'topNewsBuy', header: 'topNewsBuy'.toUpperCase() },
  //   { field: 'dividendLeader', header: 'dividendLeader'.toUpperCase() },
  //   { field: 'sociallyResponsible', header: 'sociallyResponsible'.toUpperCase() },
  //   { field: 'watchlist', header: 'watchlist'.toUpperCase() },
  //   { field: 'intersection', header: 'intersection'.toUpperCase() }
  // ]

  const showDeleteDialog = (event, rowData) => {
    setDeleteRow(rowData)
    setIsDeleteDialogVisible(true)
  }
  const deleteCompanyById = () => {
    deleteCompany(deleteRow.companyId, userActions.getCurrentUser())
    setFirst(1)
    setIsDeleteDialogVisible(false)
  }
  const activeCompanyById = (event, rowData) => {
    activeCompany(rowData.companyId, !rowData.active)
    //setFirst(0)
  }
  const editCompany = (id) => {
    history.push({
      pathname: '/dashboard/edit-company/' + id
    })
  }
  const actionTemplate = (rowData) => {
    return <div className="flexCenterCenter">
      {(rowData.active) ? <i className="pi pi-eye-slash m-r-10 pointer" title="De-Activate" onClick={(event) => activeCompanyById(event, rowData)}></i> : <i className="pi pi-eye m-r-10 pointer" title="Activate" onClick={(event) => activeCompanyById(event, rowData)}></i>}
      <i className="pi pi-pencil m-r-5 pointer" title="Edit Company" onClick={() => { editCompany(rowData.companyId) }}></i>
      <i className="pi pi-trash pointer" onClick={(event) => showDeleteDialog(event, rowData)}></i>
    </div>
  }

  const logoTemplate = (rowData) => {
    return rowData.logoPath && rowData.logoPath.trim().length > 0 && (rowData.logoURL ? <div className="flexCenterCenter">
      <img alt="Company Logo" src={`${rowData.logoPath}`} style={{ width: '31px' }}></img>
    </div> : <div className="flexCenterCenter">
        <img alt="Company Logo" src={`data:image/jpeg;base64,${rowData.encodedImageString}`} style={{ width: '20px' }}></img>
      </div>)
  }

  const companyTemplate = (rowData, column) => {
    if (column.field === 'industry.name')
      return (<div className="customnowrap" title={rowData.industry ? rowData.industry.name : ''} >{rowData.industry ? rowData.industry.name : ''}</div>)
    if (column.field === 'sector.name')
      return (<div className="customnowrap" title={rowData.sector.name} >{rowData.sector.name}</div>)
    if (column.field === 'exchange.name')
      return (<div className="customnowrap" title={rowData.exchange.name} >{rowData.exchange.name}</div>)
    if (column.field === 'ticker')
      return (<div className="customnowrap" title={rowData.ticker} >{rowData.ticker}</div>)
    if (column.field === 'marketCapitalization')
      return (<div className="customnowrap" title={rowData.marketCapitalization} >{rowData.marketCapitalization}</div>)
    if (column.field === 'exchangeCountry')
      return (<div className="customnowrap" title={rowData.exchangeCountry} >{rowData.exchangeCountry}</div>)
    if (column.field === 'earningsYeild')
      return (<div className="customnowrap" title={rowData.earningsYeild} >{rowData.earningsYeild}</div>)
    if (column.field === 'name')
      return (<div className="customnowrap" title={rowData.name} >{rowData.name}</div>)
  }

  function CopyPasteClick() {
    history.push('/dashboard/import-data')
  }
  function AddNewCompanyClick() {
    history.push('/dashboard/add-company')
  }
  const BackClick = () => {
    history.goBack()
  }
  /* Row Editing */
  const onEditorValueChange = (props, value) => {
    const updatedCompany = [...props.value]

    const dotIndex = props.field.indexOf('.')
    if (dotIndex > -1) {
      const masterField = props.field.substring(0, dotIndex)
      const subField = props.field.substring(dotIndex + 1)
      updatedCompany[props.rowIndex][masterField][subField] = value
    } else {
      updatedCompany[props.rowIndex][props.field] = (props.field === 'ticker') ? value ? value.toUpperCase() : '' : value
    }
    updatedCompany[props.rowIndex]['isUpdated'] = true
    setCompanyData(updatedCompany)
    setUpdatedRows(true)
  }

  const onDropDownValueChange = (props, value, dataList) => {
    let filtered = {}
    if (dataList.length > 0) {
      filtered = dataList.filter(a => a.value === value)
      delete filtered[0].value
    }
    const updatedCompany = [...props.value]
    console.log(props.field)
    const dotIndex = props.field.indexOf('.')
    if (dotIndex > -1) {
      const masterField = props.field.substring(0, dotIndex)
      //const subField = props.field.substring(dotIndex + 1)
      updatedCompany[props.rowIndex][masterField] = filtered[0]
    } else {
      updatedCompany[props.rowIndex][props.field] = filtered[0]
    }
    updatedCompany[props.rowIndex]['isUpdated'] = true
    if (props.field === 'sector.name') {
      updatedCompany[props.rowIndex]['industry'] = { name: '', id: -1 }
    }
    setUpdatedRows(true)
    setCompanyData(updatedCompany)
  }

  const inputTextEditor = (props, field) => {

    const dotIndex = field.indexOf('.')
    if (dotIndex > -1) {
      const masterField = field.substring(0, dotIndex)
      const subField = field.substring(dotIndex + 1)
      return <InputText type="text" value={props.rowData[masterField][subField]} onChange={(e) => onEditorValueChange(props, e.target.value)} />
    }
    return <InputText type="text" value={props.rowData[field]} onChange={(e) => onEditorValueChange(props, e.target.value)} />
  }
  const numberInputTextEditor = (props, field) => {
    return <InputText type="number" value={props.rowData[field]} onChange={(e) => onEditorValueChange(props, e.target.value)} />
    //return  <NumberFormat name="marketCapitalization"  thousandSeparator={true} value={props.rowData[field]} onChange={(e) => onEditorValueChange(props, e.target.value)} className="inputHolder--inputBox"/>
  }
  const textBoxEditor = (props) => {

    return inputTextEditor(props, props.field)
  }
  const numberEditor = (props => {
    return numberInputTextEditor(props, props.field)
  })
  const requiredValidator = (props) => {
    const value = props.rowData[props.field]
    return value && value.length > 0
  }
  const dropDownEditor = (props) => {
    return (
      <Dropdown dataKey="value" value={props.value[props.rowIndex][props.field]} options={booleanList} key={props.value[props.rowIndex][props.field]}
        onChange={(e) => onEditorValueChange(props, e.value)} style={{ width: '100%' }} placeholder="Select" />
    )
  }

  const dropDownGrowthTypeEditor = (props) => {
    return (
      <Dropdown value={props.value[props.rowIndex][props.field]} options={growth} key={props.value[props.rowIndex][props.field]}
        onChange={(e) => onEditorValueChange(props, e.value)} style={{ width: '100%' }} placeholder="Select" />
    )
  }
  const updateCompany = () => {
    let companyArray = []
    companyArray = companyData.filter(f => f.isUpdated === true)
    const updateArray = []
    const errors = []
    const errorCompanyList = []
    companyArray.map(function (company) {

      if (company.marketCapitalization === '') {
        company.marketCapitalization = 0
      }

      company.updatedBy = userActions.getCurrentUser()
      const error = companyValidation.mandatory(company, 3)
      if (Object.keys(error).length > 0) {
        errors.push(error)
        errorCompanyList.push(company)
      }
      else {
        const companyFiltered = companyList.filter(a => a.companyId === parseInt(company.companyId))
        companyFiltered[0].ticker = company.ticker
        companyFiltered[0].name = company.name
        companyFiltered[0].marketCapitalization = company.marketCapitalization
        companyFiltered[0].logoPath = company.logoPath
        companyFiltered[0].exchangeId = (company.exchange.id === -1 || company.exchange.id === 0) ? null : company.exchange.id
        companyFiltered[0].exchange = (company.exchange.id === -1 || company.exchange.id === 0) ? null : company.exchange
        companyFiltered[0].industryId = company.industry.id
        companyFiltered[0].sectorId = company.sector.id
        companyFiltered[0].exchangeName = (company.exchange.id === -1 || company.exchange.id === 0) ? null : company.exchange.name
        companyFiltered[0].industryName = company.industry.name
        companyFiltered[0].sectorName = company.sector.name
        companyFiltered[0].exchangeCountry = company.exchangeCountry
        companyFiltered[0].earningsYeild = company.earningsYeild
        companyFiltered[0].barriers = company.barriers
        companyFiltered[0].financialStrength = company.financialStrength
        companyFiltered[0].momentum = company.momentum
        companyFiltered[0].underValued = company.underValued
        companyFiltered[0].growthType = company.growthType
        companyFiltered[0].topNewsBuy = company.topNewsBuy
        companyFiltered[0].dividendLeader = company.dividendLeader
        companyFiltered[0].sociallyResponsible = company.sociallyResponsible
        companyFiltered[0].watchlist = company.watchlist
        companyFiltered[0].intersection = company.intersection
        companyFiltered[0].subBrands = []
        companyFiltered[0].updatedBy = userActions.getCurrentUser()
        delete companyFiltered[0].updatedOn
        updateArray.push(companyFiltered[0])
      }
      return company
    })
    setUpdateCount(0)
    setDuplicateCount(0)
    setFailedCount(errorCompanyList.length)
    if (updateArray && updateArray.length > 0) {
      setUpdatedRows(false)
      bulkUpdate(updateArray)
    }
  }
  const cancelEdit = () => {
    setCompanyProcess()
    setUpdatedRows(false)
  }
  const searchByName = () => {
    getCompanyByPage(0, pageSize, search, type, typeId, '')

  }
  const onSearchChange = (e) => {
    const { value } = e.target
    setSearch(value)
  }
  const onEnterKeySearch = (event) => {
    var code = (event.keyCode ? event.keyCode : event.which)
    if (code === 13) {
      searchByName()
    }

  }
  const onPageChange = (event) => {
    setFirst(event.first)
    if (type === 'search'){
      getCompanyByPage(event.page, pageSize, typeId, type, '', '')
    }
    else{  
       getCompanyByPage(event.page, pageSize, search, type, typeId, '')
    }
  }

  const lookupEditor = (props) => {
    let dataList = []
    let module = 'sector'
    switch (props.field) {
      case 'sector.name':
        dataList = masterList.sector.map((s) => {
          return { name: s.name, id: s.sectorId, value: s.sectorId }
        })
        module = 'sector'
        break
      case 'exchange.name':
        dataList = masterList.exchange.map((s) => {
          return { name: s.name, id: s.exchangeId, value: s.exchangeId }
        })
        module = 'exchange'
        break
      case 'industry.name':
        const selectedId = companyData[props.rowIndex]['sector'].id
        dataList = masterList.industry.map((i) => {
          if (i.sector && i.sector.sectorId === selectedId) {
            return { name: i.name, id: i.industryId, value: i.industryId }
          }
          return null
          //}
        })
        module = 'industry'
        break
      default:
        break
    }
    if (props.field === 'industry.name') {
      const tempRows = [...dataList]
      dataList = tempRows.filter(f => f != null)
    }
    return (
      <Dropdown value={props.value[props.rowIndex][module]['id']}
        options={dataList}
        optionLabel="name"
        key={props.value[props.rowIndex][module]['id']}
        dataKey="value"
        onChange={(e) => onDropDownValueChange(props, e.value, dataList)} style={{ width: '100%' }} placeholder={'Select a ' + module} />
    )
  }

  const footer = (
    <div>
      <Button label="OK" icon="pi pi-check" onClick={() => deleteCompanyById()} />
      <Button label="Cancel" className="p-button-raised p-button-secondary" icon="pi pi-times" onClick={() => setIsDeleteDialogVisible(false)} />
    </div>
  )

  const [expandedRows, setExpandedRows] = useState({})

  const rowExpansionTemplate = () => {
    const currentId = parseInt(Object.keys(expandedRows)[0])
    let brandList = []
    const companyfiltered = companyList.filter(a => a.companyId === parseInt(currentId))
    if (companyfiltered.length === 0 || (companyfiltered.length > 0 && !companyfiltered[0].subBrandsCompany)) {
    } else {
      brandList = companyfiltered[0].subBrandsCompany
    }
    return (
      <SubBrandComponent
        brandList={brandList}
        bulkUpdate={bulkUpdate}
        parentCompanyId={currentId}
        deleteCompany={deleteCompany}
        bulkUpdateSuccessMessage={bulkUpdateSuccessMessage}
        showGrowlMessage={showGrowlMessage}
        bulkUpdatesubBrand={bulkUpdatesubBrand}
        clearAllMessages={clearAllMessages}
        isAddCompany={false}
      />
    )
  }

  const setExpandRowValue = (data) => {
    const currentId = Object.keys(data)[0]
    const dataNew = {}
    dataNew[currentId] = true
    setExpandedRows(dataNew)
  }

  return (
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper">
        <Card className="cardBase addSector">
          <div className="titleCon m-b-20">
            <p className="title flex">
              <img src={back} alt={back} className="m-r-10 pointer" onClick={() => BackClick()} />MANAGE COMPANIES
            </p>
            <div className="flex">
              <div className="customBtnContainer m-r-20">
                {totalRecords > 0 && <div className="pointer m-r-10" >{totalRecords} records found</div>}

                <Button icon="pi pi-plus" onClick={AddNewCompanyClick} className="addBtnCustom" />
                <div className="pointer" onClick={AddNewCompanyClick}>Add New Company</div>
              </div>
              <div className="customBtnContainer m-r-20">
                <Button icon="pi pi-copy" onClick={CopyPasteClick} className="addBtnCustom" /> <div className="pointer" onClick={CopyPasteClick}>Copy & Paste</div>
              </div>
              <div className="p-inputgroup customSearch">
                <InputText placeholder="Search" value={search} onChange={onSearchChange} onKeyUp={(e) => onEnterKeySearch(e)} />
                <Button icon="pi pi-search" className="p-button-warning" onClick={() => searchByName()} />
              </div>
            </div>
          </div>
          {(bulkUpdateResult && updateCount >= 0) || failedCount > 0 ? <div className="flex">
            <div className="m-r-10 yellow-bg">Updated : {updateCount}</div>
            <div className="m-r-10 red-bg">Failed : {failedCount}</div>
            <div>Duplicate : {duplicateCount}</div>
          </div> : ''
          }
          <DataTable value={companyData} scrollable={true} emptyMessage={isCompanyLoading ? '' : 'No Companies Found'} totalRecords={totalRecords} rows={pageSize} responsive={true}
            style={{ marginTop: '30px', width: '100%' }} scrollHeight="90vh" frozenWidth="500px" paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            dataKey="companyId" expandedRows={expandedRows}
            onRowToggle={e => setExpandRowValue(e.data)}
            rowExpansionTemplate={() => rowExpansionTemplate()} className="dataTableCustom">
            <Column key={'action'} body={actionTemplate} style={{ textAlign: 'center', width: '70px', height: '52px' }} header="ACTION" frozen={true} />
            <Column editor={textBoxEditor} editorValidator={requiredValidator} key="name" field="name" body={companyTemplate} style={{ textAlign: 'left', width: '200px' }} header="COMPANY NAME" frozen={true} />
            <Column editor={textBoxEditor} key={'ticker'} field={'ticker'} body={companyTemplate} style={{ textAlign: 'left', width: '100px' }} header={'ticker'.toUpperCase()} frozen={true} />
            <Column editor={textBoxEditor} editorValidator={requiredValidator} key={'logoPath'} field="logoPath" body={logoTemplate} style={{ textAlign: 'left', width: '65px', height: '52px' }} header="LOGO" frozen={true} />
            <Column header='SUB BRAND' frozen={true} expander={true} style={{ width: '70px', textAlign: 'left' }} />
            <Column editor={lookupEditor} key={'sector.name'} field={'sector.name'} body={companyTemplate} style={{ textAlign: 'left', width: '150px' }} header='SECTOR' />
            <Column editor={lookupEditor} key={'industry.name'} field={'industry.name'} body={companyTemplate} style={{ textAlign: 'left', width: '150px' }} header='INDUSTRY' />
            <Column editor={lookupEditor} key={'exchange.name'} field={'exchange.name'} body={companyTemplate} style={{ textAlign: 'left', width: '150px' }} header={'exchange'.toUpperCase()} />
            <Column editor={numberEditor} key={'marketcap'} field={'marketCapitalization'} body={companyTemplate} style={{ textAlign: 'right', width: '200px' }} header={'Market Capitalization (usd)'.toUpperCase()} />
            <Column editor={textBoxEditor} key={'exchangeCountry'} field={'exchangeCountry'} body={companyTemplate} style={{ textAlign: 'left', width: '200px' }} header='EXCHANGE COUNTRY' />
            <Column editor={textBoxEditor} key={'earningsYeild'} field={'earningsYeild'} body={companyTemplate} style={{ textAlign: 'left', width: '200px' }} header={'earnings Yield'.toUpperCase()} />
            <Column editor={dropDownEditor} key={'barriers'} field={'barriers'} style={{ textAlign: 'left', width: '100px', textTransform: 'uppercase' }} header={'barriers'.toUpperCase()} />
            <Column editor={dropDownEditor} key={'financialStrength'} field={'financialStrength'} style={{ textAlign: 'left', width: '200px', textTransform: 'uppercase' }} header={'financial Strength'.toUpperCase()} />
            <Column editor={dropDownEditor} key={'momentum'} field={'momentum'} style={{ textAlign: 'left', width: '120px', textTransform: 'uppercase' }} header={'momentum'.toUpperCase()} />
            <Column editor={dropDownEditor} key={'underValued'} field={'underValued'} style={{ textAlign: 'left', width: '120px', textTransform: 'uppercase' }} header={'UNDER VALUED'.toUpperCase()} />
            <Column editor={dropDownGrowthTypeEditor} key={'growthType'} field={'growthType'} style={{ textAlign: 'left', width: '120px', textTransform: 'uppercase' }} header={'GROWTH TYPE'.toUpperCase()} />
            <Column editor={dropDownEditor} key={'topNewsBuy'} field={'topNewsBuy'} style={{ textAlign: 'left', width: '130px', textTransform: 'uppercase' }} header={'top New Buys'.toUpperCase()} />
            <Column editor={dropDownEditor} key={'dividendLeader'} field={'dividendLeader'} style={{ textAlign: 'left', width: '120px', textTransform: 'uppercase' }} header={'dividend Leader'.toUpperCase()} />
            <Column editor={dropDownEditor} key={'sociallyResponsible'} field={'sociallyResponsible'} style={{ textAlign: 'left', width: '120px', textTransform: 'uppercase' }} header={'socially Responsible'.toUpperCase()} />
            <Column editor={dropDownEditor} key={'watchlist'} field={'watchlist'} style={{ textAlign: 'left', width: '110px', textTransform: 'uppercase' }} header={'WATCH LIST'} />
            <Column editor={dropDownEditor} key='intersection' field={'intersection'} style={{ textAlign: 'left', width: '120px', textTransform: 'uppercase' }} header={'inter section'.toUpperCase()} />
          </DataTable>
          {companyData.length > 0 &&
            <div className="p-col-12 p-0">
              <Paginator first={first} rows={pageSize} totalRecords={totalRecords} onPageChange={onPageChange}></Paginator>
            </div>
          }
          <div className="flex m-t-10 p-justify-end">
            <div className="m-r-10">
              {updatedRows ? <Button label="Clear" className="p-button-raised p-button-rounded inputHolder--formBtn" onClick={() => cancelEdit()} /> : ''}
            </div>
            <div>
              {updatedRows ? <Button label="Save" className="p-button-raised p-button-rounded inputHolder--formBtn" onClick={updateCompany} /> : ''}
            </div>
          </div>
        </Card>
      </div>
      <Dialog header="Delete Company" footer={footer} visible={isDeleteDialogVisible} style={{ width: '50vw' }} modal={true} onHide={() => setIsDeleteDialogVisible(false)}>
        <div>Are you sure you want to delete this company?</div>
      </Dialog>
    </div>
  )
}

ManageCompanyComponent.propTypes = {
  companyList: PropTypes.array,
  totalRecords: PropTypes.number,
  getCompanyByPage: PropTypes.func,
  bulkUpdate: PropTypes.func,
  deleteCompany: PropTypes.func,
  activeCompany: PropTypes.func,
  type: PropTypes.string,
  typeId: PropTypes.string,
  bulkUpdateSuccessMessage: PropTypes.string,
  showGrowlMessage: PropTypes.func,
  bulkUpdatesubBrand: PropTypes.func,
  currentPage: PropTypes.number,
  masterList: PropTypes.object,
  bulkUpdateResponse: PropTypes.object,
  isCompanyLoading: PropTypes.bool,
  clearAllMessages: PropTypes.func,
}

export default ManageCompanyComponent

